// Third Party Imports
import React from 'react';
import PropTypes from 'prop-types';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

// Relative Imports
import './MainContent.less';

class MainContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {skipComponent} = this.props;
        const {panelContent, enableLoadOverlay} = this.props;
        return (
            <div>
                {(skipComponent) ? <div>{panelContent}</div> : <div className="main-content">
                    <div className="app-panel">{panelContent}</div>
                </div>
                }
                {
                    (enableLoadOverlay) ? <LoadingOverlay loading transition={false} transitionAppear={false}/> : null
                }
            </div>
        );
    }
}

MainContent.propTypes = {
    panelContent: PropTypes.element.isRequired
};

export default MainContent;
